import Main from '@/views/administracion/planeacion/configuracion/Main.vue';
import MainPlantillas from '@/views/administracion/planeacion/configuracion/plantillas/Main.vue';
import MainEtiquetas from '@/views/administracion/planeacion/configuracion/etiquetas/Main.vue';

const auth = ['Planeación:ver'];
const scopes = ['Planeación:crear', 'Planeación:editar', 'Planeación:eliminar'];

const configuracion = [
  {
    path: 'configuracion',
    meta: {
      title: 'Configuración',
      auth,
    },
    component: Main,
    children: [
      {
        name: 'planeacionConfiguracionPlantillas',
        path: 'plantillas',
        meta: {
          title: 'Plantillas',
          auth,
          scopes,
        },
        component: MainPlantillas,
        children: [],
      },
      {
        name: 'planeacionConfiguracionEtiquetas',
        path: 'etiquetas',
        meta: {
          title: 'Etiquetas',
          auth,
          scopes,
        },
        component: MainEtiquetas,
        children: [],
      },
    ],
  },
];

export default configuracion;
